import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useFeedbackStore } from "../stores/feedback.js";
import { useSettingsStore } from "../stores/settings.js";
import { useMetricsStore } from "../stores/metrics.js";

export function useNotifications() {
  const messages = useFeedbackStore((s) => s.messages);
  const settings = useSettingsStore();
  const addCostPoint = useMetricsStore((s) => s.addCostPoint);
  const addRunCompletion = useMetricsStore((s) => s.addRunCompletion);
  const lastCount = useRef(0);

  useEffect(() => {
    if (messages.length <= lastCount.current) {
      lastCount.current = messages.length;
      return;
    }

    // Process new messages
    const newMessages = messages.slice(lastCount.current);
    lastCount.current = messages.length;

    for (const msg of newMessages) {
      const payload = msg.payload ?? {};
      const agentName = msg.source?.name ?? "Agent";

      // Track metrics
      if (msg.type === "completion" && payload.usage?.totalCostUsd) {
        addCostPoint(payload.usage.totalCostUsd);
      }

      // Toast notifications
      if (msg.type === "completion" && settings.notifyOnRunComplete) {
        addRunCompletion(true);
        toast.success(`${agentName} completed`, {
          description: payload.summary?.slice(0, 80) ?? "Task finished successfully",
        });
      }

      if (msg.type === "error" && settings.notifyOnError) {
        addRunCompletion(false);
        toast.error(`${agentName} error`, {
          description: payload.message?.slice(0, 80) ?? "An error occurred",
        });
      }

      if (msg.type === "request-for-input" && settings.notifyOnInputRequest) {
        toast.warning("Input required", {
          description: payload.question?.slice(0, 80) ?? "An agent needs your input",
        });
      }
    }
  }, [messages, settings, addCostPoint, addRunCompletion]);
}
